import * as React from 'react';
import logo from '../images/powered_by_google_on_white.png';
declare var google: any;

interface GooglePlacesProps {
    addressId: string;
    addressLabel: string;
    placeholder: string;
    className: string;
    useLargeLabel: boolean;
    afterValid(data: any): void;
}

//interface for storing results of address from google
interface addressDetails {
    fullAddress: string;
    street_number: string;
    route: string;
    locality: string;
    administrative_area_level_1: string;
    country: string;
    postal_code: string;
    latitude: number;
    longitude: number;
    placeId: string;
};

//interface for storing address types that we need to get from google
interface componentForm {
    street_number: string;
    route: string;
    locality: string;
    administrative_area_level_1: string;
    country: string;
    postal_code: string;
};

interface GooglePlacesDetails {
    autocomplete?: any;
    addressDetails: addressDetails;
    componentForm: componentForm;
}

export default class GooglePlaces extends React.Component<GooglePlacesProps, GooglePlacesDetails> {
    constructor(props: GooglePlacesProps) {
        super(props);

        this.state = {
            addressDetails: {
                fullAddress: "",
                street_number: "",
                route: "",
                locality: "",
                administrative_area_level_1: "",
                country: "",
                postal_code: "",
                latitude: 0,
                longitude: 0,
                placeId: ""
            },
            componentForm: {
                street_number: 'short_name',
                route: 'long_name',
                locality: 'long_name',
                administrative_area_level_1: 'short_name',
                country: 'long_name',
                postal_code: 'short_name'
            }
        }
    }

    handleChange = (e: any) => {
        let change: any = {};
        change[e.target.name] = e.target.value;
        this.setState(change);
    }

    fillInAddress = () => {
        // Get the place details from the autocomplete object.
        var place = this.state.autocomplete.getPlace();
        let form: any = this.state.componentForm;
        let address: any = this.state.addressDetails;
        for (var i = 0; i < place.address_components.length; i++) {
            var addressType = place.address_components[i].types[0];

            if (form[addressType]) {
                var val = place.address_components[i][form[addressType]];
                address[addressType] = val;
            }
        }
        address["latitude"] = place.geometry.location.lat();
        address["longitude"] = place.geometry.location.lng();
        address["placeId"] = place.place_id;
        address["fullAddress"] = place.formatted_address;

        this.props.afterValid({ addressDetails: address });
    }

    public componentDidMount() {
        var autoComp = document.getElementById(this.props.addressId) as HTMLInputElement;

        if (autoComp) {
            var autocomplete = new google.maps.places.Autocomplete((autoComp), { types: ['geocode'] });
            // Set initial restrict to the greater list of countries.
            autocomplete.setComponentRestrictions(
                { 'country': ['au'] });

            // Specify only the data fields that are needed.
            autocomplete.setFields(
                ['address_components', 'geometry', 'formatted_address', 'place_id', 'name']);
            autocomplete.addListener('place_changed', this.fillInAddress);
            this.setState({ autocomplete: autocomplete });
        }
    }

    public render() {
        return (
            <div>
                <label className={this.props.className} htmlFor="siteAddr">
                    <span className={"label" + (this.props.useLargeLabel ? " label-large" : "")}>{this.props.addressLabel}</span>
                    <input className="input" id={this.props.addressId} placeholder={this.props.placeholder} type="text"></input>
                </label>
                <img className={this.props.useLargeLabel ? "marginLeftLabelLarge" : "marginLeftLabel"} src={logo}></img>
            </div>
        );
    }
}
